import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

export interface EngagementTrendChartProps {
  data: {
    categories: string[];
    series: Record<string, number | string>;
  };
}
const EngagementTrendChart = ({ data }: EngagementTrendChartProps): React.ReactElement => {
  const chartOptions = {
    chart: {
      type: 'area',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: 'Engagement Trend',
    },
    plotOptions: {
      area: {
        fillOpacity: 0.3,
      },
    },
    xAxis: {
      categories: data?.categories,
    },
    yAxis: {
      title: {
        text: 'Engagement',
      },
    },
    series: data?.series,
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default EngagementTrendChart;
